import { type Ripple } from "@dashboard/ripples/types";

export const rippleNewCustomersView: Ripple = {
  type: "feature",
  ID: "new-customers-view",
  TTL_seconds: 0, // 60 * 60 * 24 * 7 : 7 days
  dateAdded: new Date(2026, 4, 26),
  content: {
    oneLiner: "New Customers View",
    // '고객' → '회원' 명칭 통일 (2026-10-08 KST)
    contextual:
      "회원 프로필에 새로운 뷰가 추가되었습니다. 주요 회원 정보를 더 쉽게 스캔할 수 있습니다.",
    global:
      "Customer profiles have a refreshed view that makes customer details easier to scan from the Customers section or directly from an order. Use it to review customer information, addresses, order context, and related customer data faster.",
  },
};
